import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
    ButtonComponent,
    CheckboxComponent,
    IconComponent,
    InputComponent,
    InputGroupComponent,
    SpinnerComponent,
    TextareaComponent,
    OptionComponent,
    SelectComponent,
    TooltipDirective
} from '@epd/pattern-library';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

import { chatViewComponents } from './components/chat-view-components';
import { ChatViewComponent } from './components/chat-view/chat-view.component';
import { ChatService } from './services/chat/chat.service';
import { InstructionsPanelService } from './services/instructions-panel/instructions-panel.service';
import { OutputHelpersService } from './services/output-helpers/output-helpers.service';

@NgModule({
    declarations: [...chatViewComponents],
    imports: [
        MarkdownModule.forChild(),
        IconComponent,
        InputGroupComponent,
        InputComponent,
        ButtonComponent,
        CheckboxComponent,
        NgIf,
        NgFor,
        NgClass,
        OptionComponent,
        SelectComponent,
        ReactiveFormsModule,
        SpinnerComponent,
        TextareaComponent,
        TooltipDirective
    ],
    exports: [ChatViewComponent],
    providers: [ChatService, InstructionsPanelService, OutputHelpersService]
})
export class ChatViewModule {}
